import { useCallback, useEffect, useState } from "react";
import Logger from "../../../services/Logger";
import AdminCrossBoardService from "./AdminCrossBoardService";

export const usePuzzleData = (id, refresh = 0) => {
    const [crossTpl, setCrossTpl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCrossTpl = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const result = await AdminCrossBoardService.requestCrossTpl(id);
            setCrossTpl(result);
        } catch (err) {
            Logger.error("Error fetching puzzle:", err);
            setError("Failed to fetch puzzle data. Please try again.");
        } finally {
            setLoading(false);
        }
    }, [id]);

    const refetch = useCallback(async () => {
        if (id) {
            await fetchCrossTpl();
        }
    }, [id, fetchCrossTpl]);

    useEffect(() => {
        if (id) {
            fetchCrossTpl();
        }
    }, [id, refresh, fetchCrossTpl]);

    return { crossTpl, loading, error, refetch };
};

